import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IGroupSetInfo } from '../../models/IGroupSetInfo';
import { createBaseRestConfig } from '../GroupSetsServerApiHelper';

export interface IUpdateGroupSetRequestBody {
    groupSet: {
        name: string;
    };
}

export interface IUpdateGroupSetResult extends IResult {
    groupSet: {
        name: string;
    };
}

export async function updateGroupSet(groupSet: IGroupSetInfo, name: string): Promise<IUpdateGroupSetResult> {
    const body: IUpdateGroupSetRequestBody = {
        groupSet: {
            name: name
        }
    };

    const config: RestApiRequestConfig<{}, {}> = {
        ...createBaseRestConfig(),
        httpMethod: 'PUT',
        endpoint: `groupsets/` + groupSet.id,
        requestBody: body
    };

    let response = makeRestApiRequest<{}, any, {}>(config);
    return response.then((result: any) => {
        return result;
    }, (error) => Promise.reject(error));
}